import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommunityCard from '../components/CommunityCard';

const Communities = () => {
  const navigate = useNavigate();

  const images = [
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745267500/image_tfk0n3.png',
      label: 'Environmental',
      route: '/EsgPage1',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745267500/image-1_r762a6.png',
      label: 'Socials',
      route: '/EsgPage2',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745267508/image_41_yjf99s.png',
      label: 'Governance',
      route: '/EsgPage3',
    },
  ];

  return (
    <div className='bg-white'>
      <div className='md:pt-10 md:px-28 px-4 pt-4'>
        <h1 className='md:text-[36px] font-bold text-[#FDBD26]'>Communities</h1>
        <p className='md:text-[32px] text-[8px] font-medium'>
        ​FarmNet communities are collaborative networks designed to support farmers by providing access to information, resources, and market opportunities. These platforms aim to enhance agricultural productivity, sustainability, and profitability, particularly for smallholder and emerging farmers..
        </p>

        <CommunityCard />

       <div className='md:p-6 p-2 bg-[#2E453D] rounded-md '> 
       <div className=' '>
         <div className='flex justify-between  md:-mt-2'>
         <h1 className='md:text-[36px] text-[10px] font-bold text-[#FDBD26]'>
            ENVIRONMENTAL SOCIAL & GOVERNANCE
          </h1>
          <div className="flex md:space-x-6">

          <div className="flex items-center flex-shrink-0 md:mt-0 md:pr-0 pr-3 mt-3">
            <p className="md:text-[16px] text-[5px]  text-white px-2 md:px-5 md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
            VIEW MORE
            </p>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
              alt="Expand"
              className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] md:flex hidden object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
            />
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
              alt="Expand"
              className="w-[20px] h-[13px] md:hidden py-[1px] flex md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
            />
          </div>
</div>
         </div>
          <div className='flex flex-row justify-center gap-2 md:mt-3'>
            {images.map((item, index) => (
              <div
                key={index}
                onClick={() => navigate(item.route)}
                className='relative w-full md:h-[110px] rounded-[10px] cursor-pointer'
              >
                <img
                  src={item.src}
                  alt={item.label}
                  className='w-full h-full object-cover rounded-[5px]'
                />
                <p className='absolute bottom-2 left-3 text-white text-[6px] md:text-[36px] font-bold font-["Inter"]'>
                  {item.label}
                </p>
              </div>
            ))}
          </div>
          <div className='md:h-4 h-2'></div>
        </div>
       </div>
      </div>
    </div>
  );
};

export default Communities;
